import { Box, Typography, Button } from '@mui/material'
import { useNavigate } from 'react-router'
import { fontSizes, fontWeights } from '../../Components/Common/Typography/TypographyStyles'
import { useAppSelector } from '../../redux/hooks'
import { selectAuthError } from '../../redux/auth/selector'
import { AuthError } from '../../redux/auth/types'

const NoAccessPage = () => {
  const navigate = useNavigate()
  const authError = useAppSelector(selectAuthError) as AuthError | null

  const handleLoginRedirect = () => {
    navigate('/login')
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        textAlign: 'center',
        padding: 3,
      }}
    >
      <Typography
        variant='h4'
        color='error'
        sx={{ fontWeight: fontWeights[700], fontSize: fontSizes.size64 }}
      >
        No Access
      </Typography>
      <Typography variant='body1' sx={{ marginY: 2, fontSize: fontSizes.size16 }}>
        You don&apos;t have permission to access this page. Please contact your administrator if you
        believe this is an error.
      </Typography>
      {authError && (
        <Box sx={{ marginY: 2 }}>
          <Typography variant='body2' color='error' sx={{ fontSize: fontSizes.size14 }}>
            {authError.message}
          </Typography>
          <Typography variant='body2' color='error' sx={{ fontSize: fontSizes.size12, mt: 0.5 }}>
            {authError.details}
          </Typography>
        </Box>
      )}
      <Button variant='contained' color='primary' onClick={handleLoginRedirect}>
        Try to Login
      </Button>
    </Box>
  )
}

export default NoAccessPage
